<template>
   <PrimeBreadcrumb  :home="home" :model="items" style="margin-top: 0px;"></PrimeBreadcrumb>

  <form @submit.prevent="save">
    <div class="p-fluid">
      <div class="p-field">
        <div class="row">
          <div class="col-3">
              <my-text-single
              v-model="my_item.cusNo"
              :label="'客戶編號'"
              :required="true"
              :maxlength="4"
            ></my-text-single> 

            

          </div>
          <div class="col-3">
            <my-text-single
              v-model="my_item.escsno"
              :label="'新竹客代'"
              :required="true"
              :maxlength="3"
            ></my-text-single>
          </div>
        
          <div class="col-3">
            <my-text-single
              v-model="my_item.weight_Min"
              :label="'重量Min'"
              :required="true"
              :maxlength="3"
            ></my-text-single>
         </div>
          <div class="col-3">
            <my-text-single
              v-model="my_item.weight_Max"
              :label="'重量Max'"
              :required="true"
              :maxlength="3"
            ></my-text-single>
         </div>
        </div>
      </div>
       <div class="p-field">
        <div class="row">
          
          <div class="col-12">
             <my-text-multi
              v-model="my_item.description"
              :label="'描述'"
              :required="true"
              :maxlength="100"
              :rows="3"
              :cols="20"
            ></my-text-multi>
          </div>
        </div>
      </div>
       
    </div>
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2">
        <PrimeButton
          label="Cancel"
          icon="pi pi-times"
          class="p-button-secondary"
          @click="closeModal()"
        />
      </div>
      <div class="col-2">
        <PrimeButton
          type="submit"
          label="Save"
          icon="pi pi-check"
          class="p-button-primary"
        />
      </div>
    </div>
  </form>

 

</template>


<script>
import service from "../service/Appservice";

export default {
  props: ["item"],
  data() {
    return {
       my_item: { 
       },
        home: {icon: 'pi pi-home', to: '/'},
            items: [
                {label: '代理'} ,
                {label: '代理維護'} ,
                {label: '客代維護'} ,
            ],
    };
  },
  computed: {
   
   user() {
     return this.$store.state.user;
    },
     clientId() {
     return this.$store.state.user?.clientId;
    },
  },
  service: null,
  created() {
    this.my_item = this.item ;
    console.log('created')
    console.log(this.my_item)
    this.service = new service();
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    save() {
    
      var self = this;
      self.my_item.createTime = new Date().toISOString();
      self.my_item.updateTime = new Date().toISOString();
 
      this.service.updateAgentEscsno(this.my_item).then((data) => {
        self.my_item = data;
        self.$emit("save", data);
        self.$emit("itemsavedone", self.my_item);
      });
    },
  },
};
</script>